module.exports = __webpack_public_path__ + "static/media/reservations-02.255ca686.png";